export default "__VITE_ASSET__dTh15hVW__"